module.exports = __webpack_public_path__ + "static/media/heart-square.944d20fd.svg";